import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import message from "../../message";

export default function UserChatsModal({ open, user, token, baseUrl, onClose }) {
  const [chatActs, setChatActs] = useState([]);
  const [chatActId, setChatActId] = useState("");
  const [chatList, setChatList] = useState([]);
  const [chatId, setChatId] = useState("");
  const [chatMessages, setChatMessages] = useState([]);
  const [chatLoading, setChatLoading] = useState(false);
  const [messageLoading, setMessageLoading] = useState(false);

  const userId = user?.id;

  const renderMessageText = (item) => {
    const type = String(item?.type || "");
    const text = String(item?.text || "");
    if (type === "text") return text;
    if (type === "image") return text ? `[图片] ${text}` : "[图片]";
    if (type === "video") return text ? `[视频] ${text}` : "[视频]";
    return text ? `[媒体] ${text}` : "[媒体]";
  };

  const resetState = () => {
    setChatActs([]);
    setChatActId("");
    setChatList([]);
    setChatId("");
    setChatMessages([]);
    setChatLoading(false);
    setMessageLoading(false);
  };

  const loadChatMessages = async (nextUserId, actId, nextChatId) => {
    if (!nextUserId || !actId || !nextChatId) return;
    if (messageLoading) return;
    setMessageLoading(true);
    try {
      const params = new URLSearchParams({
        userId: nextUserId,
        actId,
        chatId: nextChatId,
      });
      const resp = await fetch(`${baseUrl}/manager/chat/messages?${params}`, {
        headers: token ? { token } : {},
      });
      const result = await resp.json();
      if (result?.code) {
        message.toast(result.msg || "加载消息失败");
        return;
      }
      setChatMessages(result?.data?.list || []);
    } catch (error) {
      message.toast("加载消息失败");
    } finally {
      setMessageLoading(false);
    }
  };

  const loadChatList = async (nextUserId, actId) => {
    if (!nextUserId || !actId) return;
    setChatLoading(true);
    try {
      const params = new URLSearchParams({ userId: nextUserId, actId });
      const resp = await fetch(`${baseUrl}/manager/chat/list?${params}`, {
        headers: token ? { token } : {},
      });
      const result = await resp.json();
      if (result?.code) {
        message.toast(result.msg || "加载会话失败");
        return;
      }
      setChatList(result?.data?.list || []);
      setChatId("");
      setChatMessages([]);
    } catch (error) {
      message.toast("加载会话失败");
    } finally {
      setChatLoading(false);
    }
  };

  const loadChatActs = async (nextUserId) => {
    if (!nextUserId || chatLoading) return;
    setChatLoading(true);
    try {
      const params = new URLSearchParams({ userId: nextUserId });
      const resp = await fetch(`${baseUrl}/manager/chat/acts?${params}`, {
        headers: token ? { token } : {},
      });
      const result = await resp.json();
      if (result?.code) {
        message.toast(result.msg || "加载账号失败");
        return;
      }
      const list = result?.data?.list || [];
      setChatActs(list);
      const nextActId = list[0]?.id || "";
      setChatActId(nextActId);
      if (nextActId) {
        await loadChatList(nextUserId, nextActId);
      }
    } catch (error) {
      message.toast("加载账号失败");
    } finally {
      setChatLoading(false);
    }
  };

  useEffect(() => {
    if (!open) return;
    resetState();
    if (userId) {
      loadChatActs(userId);
    }
  }, [open, userId]);

  return (
    <Modal
      title={`查看${user?.account || ""}的聊天`}
      open={open}
      onCancel={onClose}
      footer={null}
      width={1120}
      style={{ top: 24 }}
      bodyStyle={{
        maxHeight: "calc(100vh - 120px)",
        overflow: "hidden",
        padding: 0,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 12,
          minHeight: 0,
          height: "calc(100vh - 160px)",
          padding: 16,
          boxSizing: "border-box",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
          <Button
            type="default"
            icon={<ReloadOutlined />}
            onClick={() => loadChatActs(userId)}
            loading={chatLoading}
          >
            刷新数据
          </Button>
        </div>
        <div style={{ display: "flex", gap: 12, flex: 1, minHeight: 0 }}>
          <div
            style={{
              width: 220,
              border: "1px solid #e5e7eb",
              borderRadius: 12,
              padding: 10,
              background: "#f8fafc",
              display: "flex",
              flexDirection: "column",
              gap: 8,
              minHeight: 0,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ fontWeight: 600, fontSize: 13 }}>账号列表</div>
              <Button
                type="text"
                icon={<ReloadOutlined />}
                onClick={() => loadChatActs(userId)}
                loading={chatLoading}
              />
            </div>
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                gap: 6,
              }}
            >
              {chatActs.length === 0 ? (
                <div style={{ fontSize: 12, color: "#9aa1aa", padding: "12px 4px" }}>
                  暂无账号
                </div>
              ) : (
                chatActs.map((act) => (
                  <div
                    key={act.id}
                    role="button"
                    tabIndex={0}
                    onClick={async () => {
                      setChatActId(act.id);
                      await loadChatList(userId, act.id);
                    }}
                    onKeyDown={async (event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        setChatActId(act.id);
                        await loadChatList(userId, act.id);
                      }
                    }}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      padding: "8px 10px",
                      borderRadius: 8,
                      border: "1px solid #e5e7eb",
                      background: chatActId === act.id ? "#dcfce7" : "#ffffff",
                      cursor: "pointer",
                    }}
                  >
                    {act.avatar ? (
                      <img
                        src={act.avatar}
                        alt={act.nickname || "avatar"}
                        style={{ width: 28, height: 28, borderRadius: 14, objectFit: "cover" }}
                      />
                    ) : (
                      <div
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: 14,
                          background: "#e5e7eb",
                        }}
                      />
                    )}
                    <div style={{ fontSize: 13, fontWeight: 600 }}>
                      {act.nickname || act.id}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
          <div
            style={{
              width: 340,
              border: "1px solid #e5e7eb",
              borderRadius: 12,
              padding: 10,
              background: "#ffffff",
              display: "flex",
              flexDirection: "column",
              gap: 8,
              minHeight: 0,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ fontWeight: 600, fontSize: 13 }}>会话列表</div>
              <Button
                type="text"
                icon={<ReloadOutlined />}
                onClick={() => loadChatList(userId, chatActId)}
                loading={chatLoading}
              />
            </div>
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                gap: 6,
              }}
            >
              {chatList.length === 0 ? (
                <div style={{ fontSize: 12, color: "#9aa1aa", padding: "12px 4px" }}>
                  暂无会话
                </div>
              ) : (
                chatList.map((item, index) => (
                  <Button
                    key={`${item.id}_${index}`}
                    type="default"
                    onClick={async () => {
                      setChatId(item.id);
                      await loadChatMessages(userId, chatActId, item.id);
                    }}
                    style={{
                      textAlign: "left",
                      height: "auto",
                      padding: "8px 10px",
                      background: chatId === item.id ? "#e0f2fe" : "#ffffff",
                      borderColor: chatId === item.id ? "#38bdf8" : "#e5e7eb",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 8, width: "100%" }}>
                      <img
                        src={
                          !item.avatar || String(item.avatar).startsWith("data:")
                            ? `${process.env.PUBLIC_URL || ""}/whatsapp-default-avatar.png`
                            : item.avatar
                        }
                        alt={item.name || "avatar"}
                        style={{ width: 28, height: 28, borderRadius: 14, objectFit: "cover" }}
                      />
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 2 }}>
                          {item.name || "-"}
                        </div>
                        <div
                          style={{
                            fontSize: 12,
                            color: "rgba(0,0,0,0.55)",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {item.lastMessage || "-"}
                        </div>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 4 }}>
                        <div style={{ fontSize: 12, color: "rgba(0,0,0,0.45)" }}>
                          {item.time || ""}
                        </div>
                        {item.unread ? (
                          <div
                            style={{
                              minWidth: 18,
                              height: 18,
                              padding: "0 6px",
                              borderRadius: 9,
                              background: "#ef4444",
                              color: "#ffffff",
                              fontSize: 11,
                              display: "inline-flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            {item.unread}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </Button>
                ))
              )}
            </div>
          </div>
          <div
            style={{
              flex: 1,
              border: "1px solid #e5e7eb",
              borderRadius: 12,
              padding: 10,
              background: "#ffffff",
              display: "flex",
              flexDirection: "column",
              gap: 8,
              minWidth: 0,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ fontWeight: 600, fontSize: 13 }}>消息列表</div>
              <Button
                type="text"
                icon={<ReloadOutlined />}
                onClick={() => loadChatMessages(userId, chatActId, chatId)}
                loading={messageLoading}
              />
            </div>
            <div
              style={{
                flex: 1,
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                gap: 8,
              }}
            >
              {messageLoading ? (
                <div style={{ fontSize: 12, color: "#9aa1aa", padding: "12px 4px" }}>
                  加载中...
                </div>
              ) : chatMessages.length === 0 ? (
                <div style={{ fontSize: 12, color: "#9aa1aa", padding: "12px 4px" }}>
                  暂无消息
                </div>
              ) : (
                chatMessages.map((item) => (
                  <div
                    key={item.id}
                    style={{
                      display: "flex",
                      justifyContent: item.direction === "out" ? "flex-end" : "flex-start",
                    }}
                  >
                    <div
                      style={{
                        maxWidth: 420,
                        padding: 10,
                        borderRadius: 10,
                        background: item.direction === "out" ? "#dcfce7" : "#f8fafc",
                        border: "1px solid #e5e7eb",
                      }}
                    >
                      <div style={{ fontSize: 11, color: "#6b7280", marginBottom: 4 }}>
                        {item.direction} · {item.type}
                        {item.time ? ` · ${item.time}` : ""}
                      </div>
                      <div style={{ fontSize: 13, color: "#111827", whiteSpace: "pre-wrap" }}>
                        {renderMessageText(item)}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
